<template>
	<div style="text-align: center;">
		<div style="border-bottom: 1px solid #f5f5f5;" >
			<br /><br /><br /><br />

			<span style="font-size: 0.8rem;">订单金额</span>
			<br><br>
			<span style="font-size: 1.8rem;">￥{{fee}}</span>
			<br><br>

		</div>

		<div class="pay-list">
			<span class="icon-box"><i class="iconfont icon-weixin"></i></span>
			<span>微信支付</span>
			<span style="float: right;"><input type="radio" value="1" v-model="channel" /></span>
		</div>
		<div class="pay-list">
			<span class="icon-box"><i class="iconfont icon-zhifubao"></i></span>
			<span>支付宝支付</span>
			<span style="float: right;"><input type="radio" value="2" v-model="channel" /></span>
		</div>

		<br><br>
		<span class="pay-buttom" @click="toPay(oid)" >确认支付</span>




		<!-- 支付宝 -->
		<form v-bind:action="alipay.action" method="post" name="punchout_form">
			<input type="hidden" name="biz_content" v-model="alipay.biz_content">
			<input type="submit" value="立即支付" style="display: none;" >
		</form>
<br /><br /><br />



		<!-- 组件使用 -->
		<!-- <foot /> -->
		<syalert ref="syalert_id" />

	</div>
</template>
<style>
	.pay-list
	{
		margin: 0.5rem auto;
		width:80%;
		text-align: left;
	}
	.pay-list span
	{
		display: inline-block;
	}
	.pay-list input
	{
		height: 2.5rem;
	}
	.icon-box
	{
		width: 2.5rem;
		height: 2.5rem;
		margin-right: 1.0rem;
		border-radius: 2.5rem;
		border: 1px solid #f5f5f5;
		line-height: 2.5rem;
		text-align: center;
	}
	.icon-weixin
	{
		color: #09BB07;
	}
	.icon-zhifubao
	{
		color: #1890FF;
	}

	.pay-buttom
	{
		display: block;
		width: 14rem;
		height: 2rem;
		margin: 0.5rem auto;

		line-height: 2rem;

		/* border-radius: 2rem; */

		font-size: 0.8rem;

		color: white;
		background-color: #e60012;
	}
</style>
<script>
	// 组件引入
	import sy from "@/sy";
	import syalert from '@/components/syalert.vue';
	// import foot from '@/components/foot.vue';

	export default {
		name: 'payment',
		components: {
			// foot,
			syalert,
		},
		data() {
			return {
				oid: 0,
				fee: 0,
				channel: 1,
				alipay:
				{
						action: '',
						biz_content: '',
				},
				inte: '',
			}
		},
		methods: {
			alipay_submit: function()
			{
				document.forms[0].submit();
			},
			check: function()
			{
				console.log('----------');
				console.log(this.forms);
			},
			toPay: function()
			{ 
				// 重命名实例
				let $_this = this;
				sy.http.get({
					url: this.$root.API + 'Payment/Pay',
					data:
					{
						oid: this.oid,
						pay: this.channel,
					},
					success: function(res) {

						if (res.state === '0')
						{
							return $_this.$refs.syalert_id.syalert(res.msg);
						}
						if( $_this.channel == 1 )
						{
							// weixin
						}
						if( $_this.channel == 2 )
						{
							// $_this.alipay = res.data;
							$_this.alipay.action = res.data.action;
							$_this.alipay.biz_content = res.data.biz_content;
							// 如果有提示会一直给他提示 知道处理完

								$_this.inte = setInterval(function() {
									
									if ($_this.alipay.action !== '')
									{
										clearInterval($_this.inte);
										// 触发表单按钮
										$_this.alipay_submit();
 
									}
								}, 500);

								//alert($_this.channel);

						}
					}
				});
			},
		},
		created() {
			this.oid = this.$router.currentRoute.query.oid;
			this.fee = this.$router.currentRoute.query.fee;
			this.fee = parseFloat(this.fee);
			this.fee = this.fee.toFixed(2);

			console.log(this.oid);
			console.log(this.fee);


			this.check();
		},
	}
</script>